import React, { useState } from 'react';
import LogoHeader from './LogoHeader';
import InvoiceTemplate from './InvoiceTemplate';
import AgreementTemplate from './AgreementTemplate';
import MailerSettingsTab from '../SettingsConfig/MailerSettingsTab';
import { getCookie } from '../utils/cookies';
import '../tabs.css';

const Templates = () => {
  const [activeTab, setActiveTab] = useState('logoHeader');
  // Owners edit owner-level mailer settings; dealers (non-owner roles) edit only
  // their own dealer's settings.
  const role = (getCookie('user_role') || '').toLowerCase();
  const isOwnerClass = ['owner', 'admin', 'superadmin'].includes(role);
  const dealerId = isOwnerClass ? null : (getCookie('dealer_id') || null);
  const dealerName = isOwnerClass ? '' : (getCookie('dealer_code') || '');

  return (
    <div className="content-container">
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={activeTab === 'logoHeader' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('logoHeader')}
        >
          Logo & Header
        </button>
        <button
          className={activeTab === 'invoice' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('invoice')}
        >
          Invoice Template
        </button>
        <button
          className={activeTab === 'agreement' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('agreement')}
        >
          Agreement Template
        </button>
        <button
          className={activeTab === 'mail' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('mail')}
        >
          Mail Settings
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'logoHeader' && <LogoHeader />}
        {activeTab === 'invoice' && <InvoiceTemplate />}
        {activeTab === 'agreement' && <AgreementTemplate />}
        {activeTab === 'mail' && <MailerSettingsTab dealerId={dealerId} dealerName={dealerName} />}
      </div>
    </div>
  );
};

export default Templates;
